
import Vue from 'vue';
import { TransformedModule } from '~/transforms/transformModules';
import { TransformedArticlePage } from '~/transforms/transformPages';
import { GeigerLocale } from '~/utility/i18n';
import { generateArticleSchema } from '~/utility/jsonld/article';

export default Vue.extend({
  name: 'articlePage',
  props: {
    modules: {
      type: Array<TransformedModule>,
      required: true,
    },
    pageData: {
      type: Object as () => TransformedArticlePage,
      required: true,
    },
  },
  head() {
    return {
      script: [
        {
          type: 'application/ld+json',
          innerHTML: JSON.stringify(generateArticleSchema(this.pageData, this.$i18n.locale as GeigerLocale)),
          body: true,
        },
      ],
      __dangerouslyDisableSanitizers: ['script'],
    };
  },
});
